module.exports = __webpack_public_path__ + "img/loading-white.c9a74883.svg";